<template>
    <Toast position="bottom-right" group="extended-toast-group">
        <template #message="slotProps">
            <div class="flex flex-col items-start flex-auto">
                <div class="font-medium text-xl leading-none mb-2">
                    <template v-if="slotProps.message.severity === 'success'">Pavyko!</template>
                    <template v-else>{{ getErrorType(slotProps.message.errorCode) }}</template>
                </div>
                <template v-if="slotProps.message.severity === 'success'">{{ slotProps.message.detail }}</template>
                <template v-else>
                    <span v-for="(item, index) in slotProps.message.detail" :key="index">
                        <template v-if="Array.isArray(item)">
                            {{ item[0] }}
                        </template>
                        <template v-else>
                            {{ item }}
                        </template>
                    </span>
                </template>
            </div>
        </template>
    </Toast>
</template>
<script setup lang="ts">
    // Imports
    import Toast from 'primevue/toast';

    // Methods
    function getErrorType(type: number): string
    {
        switch(type)
        {
            case 400:
                return 'Klaida';
            case 422:
                return 'Klaida';
            case 500:
                return 'Klaida';
            default:
                return 'Klaida'
        }
    }
</script>